
import './App.css';
import Adddata from './components/adddata';
import Mainlayout from './layouts/Mainlayout';

function App() {
  return (
    <Mainlayout>
<div className="App">
     <Adddata />
    </div>
    </Mainlayout>
  );
}

export default App;

